import gql from 'graphql-tag'

export const GET_ARRIVAL_PRODUCT_MARKUP_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
		$query: String
		$individual: Boolean = true
  ) {
    getArrivalProductMarkupPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
				query: $query
				individual: $individual
      }
    ) {
      hasMore
      total
      items {
				id
        product {
					id
					productInfo {
						titleRu
						titleKg
						titleEn
					}
					coverImage
				}
				fromPrice
				toPrice
				price
				overprice
				wholesalePrice
      }
    }
  }
`;

export const GET_ARRIVAL_PRODUCT_MARKUP_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getArrivalProductMarkup (
      data: {
        id: $id
      }
    ) {
      id
			productId
			fromPrice
			toPrice
			price
			overprice
			wholesalePrice
    }
  }
`;

export const GET_MAIN_ARRIVAL_PRODUCT_MARKUP_QUERY = gql`
  query {
    getMainArrivalProductMarkup {
      id
			price
			overprice
			wholesalePrice
    }
  }
`;
